/**
 * Category Service
 * Handles category-related API calls
 */

import api from './api';

export interface Category {
  value: string;
  label: string;
}

export const categoryService = {
  /**
   * Get all available categories
   */
  async getCategories(): Promise<Category[]> {
    try {
      const response = await api.get<{ success: boolean; data: Category[] }>('/categories');
      return response.data.data;
    } catch (error) {
      console.error('Error fetching categories:', error);
      // Return fallback categories if API fails
      return [
        { value: 'healthcare', label: 'Healthcare' },
        { value: 'personal_care', label: 'Personal Care' },
        { value: 'food_dining', label: 'Food & Dining' },
        { value: 'automotive', label: 'Automotive' },
        { value: 'fitness_sports', label: 'Fitness & Sports' },
      ];
    }
  },
};
